<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        header: 'System Tab',
        body: [
          'The user can edit the data in any of the panels by clicking the pencil and paper icon.',
        ],
      },
      {
        header: 'General Properties',
        body: [
          `The user can change the branding application name, add a header or footer location, and set the State ID Display format. The user can also set the session timeout minutes.`,
        ],
      },
      {
        header: 'Rule Properties',
        body: [
          `In the Rule Properties section, the user can edit the data validation rules and error handling.`,
        ],
      },
      {
        header: 'SMTP Properties',
        body: [
          `The user can edit the SMTP protocols in the SMTP properties sections.`,
        ],
      },
      {
        header: 'System Labels',
        body: [
          `When editing system labels the user can enter new terminology for no match and match buttons and change the near match label.`,
        ],
      },
      {
        header: 'System Message',
        body: [
          `The system message can be set and enabled in this section. It will display up to 3 lines and no more than 180 characters. Any additional lines or characters will be displayed in a modal section.`,
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
